export default __webpack_public_path__ + "static/media/3.25.1a0b6cb1.mp3";